// to handle when view more button is clicked
$j(document).ready(function(){
  let productsOnPage = $j('.product-grid-container .collection .product-grid')
  // console.log('productsOnPage',productsOnPage)
  let nextUrl = productsOnPage.attr('data-next-url')
  let loadMoreBtn = $j('.load-more-btn');
  // console.log('loadMoreBtn',loadMoreBtn)
  let loadMoreSpinner = $j('.load-more-spinner.loader');
  loadMoreSpinner.hide();
  // console.log('loadMoreSpinner document ready',loadMoreSpinner)
})

let first_clicked = false;

function ViewMore(){
  productsOnPage = $j('.product-grid-container .collection .product-grid')
  // console.log('nextUrl',nextUrl)
  if (first_clicked == false){
    nextUrl = productsOnPage.attr('data-next-url')
  }
  loadMoreBtn = $j('.load-more-btn');
  loadMoreSpinner = $j('.load-more-spinner.loader');

  // e.preventDefault();
  // console.log('clicked')
  loadMoreBtn.hide();
  // loadMoreSpinner.show();
  loadMoreSpinner.css("display","inline-block")
  // for testing
  // nextUrl = '/collections/all?page=1'
  console.log('nextUrl',nextUrl)
  $j.ajax({
    url: nextUrl,
    type: "GET",
    dataType: "html",
    success: function(nextPage){
      // console.log('nextPage',nextPage)
      loadMoreSpinner.hide();
      let newProducts = $j(nextPage).find('.collection .product-grid')
      productsOnPage.append(newProducts.html());
      
      // initiate wishlist button (this part only will run if combined listing for collection is not enabled)
      $j(newProducts).find('[button-wishlist]').each(function() {
        var product_handle = $j(this).attr('data-product-handle')
        // console.log('product-handle',product_handle)
        var wishlist_button = document.querySelector('[button-wishlist][data-product-handle="'+product_handle+'"]')
        const productHandle = wishlist_button.dataset.productHandle || false;
        if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
        if (wishlistContains(productHandle)){
          wishlist_button.classList.add(BUTTON_ACTIVE_CLASS);
          // to display add wishlist / remove wishlist
          try{
            let button_text = button.querySelector('.btn__inner').querySelector('.btn__text')
            button_text.innerText = "Remove Wishlist"
          }
          catch(err) {
          }
    
        } 
        wishlist_button.addEventListener('click', () => {
          // to display add wishlist / remove wishlist
          updateWishlist(productHandle, wishlist_button);
          wishlist_button.classList.toggle(BUTTON_ACTIVE_CLASS);
          updateWishlistCount();
        });
        
      })

      $j(newProducts).find('.product-card-wrapper').each(function() {
        console.log('$j(this)', $j(this).attr('js-product-id'),$j(this).attr('js-product-id'))
        var product_id = $j(this).attr('js-product-id')
        var identifier_value = $j(this).attr('js-product-identifier')
        var variant_value = $j(this).attr('js-product-variant-value')
        var product_handle = $j(this).attr('js-product-handle')
        $j(`.custom-selector-wrapper--${product_id} div`).removeClass('loader-selector');
        if (product_id != undefined){
          // console.log('enter before getProductColorSwatch',identifier,product_id,identifier_value,variant_value,product_handle,filter_value)
          getProductColorSwatch(identifier,identifier_value,variant_value,product_id,filter_value)
        }
       
      })
      
      let newUrl = newProducts.attr('data-next-url');
      // console.log('newUrl',newUrl)
      nextUrl = newUrl
      first_clicked = true
      //setCollectionGridHeight()
      if(newUrl){
        loadMoreBtn.show();
      }else{
        // setCollectionGridHeight()
      }
      // if (window.AOS) { AOS.refreshHard() }
    }
  })

}
// end to handle when button is clicked

// // for infinite scroll to init wishlist button and combined listing
// var observer = new MutationObserver(function(mutations) {
//   mutations.forEach(function(mutation) {
//     // console.log('mutation',mutation)
//     // do stuff when

//     // product-grid
//     if (mutation.target.classList.contains("grid__item")){
//       console.log("enter if")
//       var initbutton = false

//       for(var child of mutation.target.childNodes){
//         if (child.classList){
//           if (child.classList.contains('product-card-wrapper')){
//             // console.log('product-card-wrapper existed')
//             var product_id= child.getAttribute('js-product-id')
//             // console.log('child',child)
//             // console.log('product_id',product_id)
//             if (product_id != null){
//               if ($j(`.custom-selector-wrapper--${product_id} div`).hasClass('loader-selector')){
//                 var identifier_value = child.getAttribute('js-product-identifier')
//                 var variant_value = child.getAttribute('js-product-variant-value')
//                 var product_handle = child.getAttribute('js-product-handle')
//                 $j(`.custom-selector-wrapper--${product_id} div`).removeClass('loader-selector');
//                 console.log('enter before getProductColorSwatch',identifier_value,variant_value,product_handle)
//                 getProductColorSwatch(identifier,identifier_value,variant_value,product_id,filter_value)
//               }
//             }
//           }
//         }
//       }
        
          
      
//       // pending init wishlist button
//       // if (window.location.pathname.indexOf('/collections/') !== -1 && window.location.pathname.indexOf('/products/') === -1 ){
//       //   // console.log($j('.collection-grid__wrapper .grid--uniform .grid-product:not(.grid-promo)').length)
//       //   // BindLoadMoreButton()
//       //   if ($j('.collection-grid__wrapper .grid--uniform .grid-product:not(.grid-promo)').length <= 36 ){
//       //     initbutton = false
//       //   }
//       //   else{
//       //     initbutton = true
//       //   }
//       // }

//       // console.log(product_handle,initbutton)
//       // if ( initbutton ){
//       //   const wishlist_button = document.querySelector('[button-wishlist][data-product-handle="'+product_handle+'"]')
//       //   // console.log('wishlistbutton',wishlist_button)
//       //   const productHandle = wishlist_button.dataset.productHandle || false;
//       //   const productType = wishlist_button.dataset.productType || false;
//       //   if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
//       //   if (wishlistContains(productHandle+'_'+productType)){
//       //     wishlist_button.classList.add(BUTTON_ACTIVE_CLASS);
//       //   } 
//       //   wishlist_button.addEventListener('click', () => {
//       //     const productHandle = wishlist_button.dataset.productHandle || false;
//       //     const productType = wishlist_button.dataset.productType || false;
//       //     updateWishlist(productHandle, wishlist_button);
//       //     // console.log(productHandle)
//       //     wishlist_button.classList.toggle(BUTTON_ACTIVE_CLASS);
//       //     updateWishlistCount();
//       //     // wishlist_button.querySelector('.icon-heart').classList.toggle('fa-solid')
//       //     // wishlist_button.querySelector('.icon-heart').classList.toggle('fa-regular')
//       //   });
//       // }
//     }
    
//     // if (mutation.target.classList.contains("grid-product")){
//     //   // console.log("grid-product",mutation.target.childNodes)
//     //   for(var child of mutation.target.childNodes){
//     //     if (child.classList){
//     //       if (child.classList.contains('grid-product__content')){
//     //         // console.log('grid-product__content')
//     //         for(var c of child.childNodes){
//     //           if (c.classList){
//     //             if (c.classList.contains('grid__item-image-wrapper')){
//     //               // console.log('grid__item-image-wrapper')
//     //               var product_id= c.getAttribute('js-product-id')
//     //               if ($j(`.custom-selector-wrapper--${product_id} div`).hasClass('loader-selector')){
//     //                 // show style in filter 
//     //                if ($j( ".filters-form-icon use").length > 0){
//     //                   if (!$j( ".filters-form-icon use" ).attr('href').startsWith('//crocs-my.myshopify.com')){
//     //                     $j( ".filters-form-icon use" ).each(function( index ) {
//     //                       link = $j( this ).attr('href').split('#')
//     //                       $j(this).attr('href','//crocs-my.myshopify.com/cdn/shop/t/3/assets/silhouetteIcons_styleFilter.svg?v=118186500769687013621720081673#'+ link[link.length-1])
//     //                     });
//     //                   }
//     //                 }
                
//     //                 // show image in filter
//     //                 if ($j('.tag--category .aos-init:not(.aos-animate)').length > 0){
//     //                   console.log("show filter image")
//     //                   $j( '.tag--category .aos-init:not(.aos-animate)' ).addClass('aos-animate')
//     //                 }
                  
//     //                 // console.log('call getProductColorSwatch')
//     //                 var product_type= c.getAttribute('js-product-type')
//     //                 var current_p_colour= c.getAttribute('js-product-colour')
//     //                 // var product_id= c.getAttribute('js-product-id')
//     //                 var product_handle = c.getAttribute('js-product-handle')
//     //                 $j(`.custom-selector-wrapper--${product_id} div`).removeClass('loader-selector');
//     //                 getProductColorSwatch(product_type,current_p_colour,product_id )

//     //                 var nexturl = $j('.collection-grid__wrapper .grid--uniform').attr('data-next-url')
//     //                 const searchParams = new URLSearchParams(nexturl);
//     //                 // console.log('nexturl swatch',nexturl)
//     //                 // console.log(parseInt(searchParams.get('page')))
//     //                 var initbutton = false

//     //                 if (window.location.pathname.indexOf('/collections/') !== -1 && window.location.pathname.indexOf('/products/') === -1 ){
//     //                   // console.log($j('.collection-grid__wrapper .grid--uniform .grid-product:not(.grid-promo)').length)
//     //                   // BindLoadMoreButton()
//     //                   if ($j('.collection-grid__wrapper .grid--uniform .grid-product:not(.grid-promo)').length <= 36 ){
//     //                     initbutton = false
//     //                   }
//     //                   else{
//     //                     initbutton = true
//     //                   }
//     //                 }
//     //                 else{
                    
//     //                 }

//     //                 // console.log(product_handle,initbutton)
//     //                 if ( initbutton ){
//     //                   const wishlist_button = document.querySelector('[button-wishlist][data-product-handle="'+product_handle+'"]')
//     //                   // console.log('wishlistbutton',wishlist_button)
//     //                   const productHandle = wishlist_button.dataset.productHandle || false;
//     //                   const productType = wishlist_button.dataset.productType || false;
//     //                   if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
//     //                   if (wishlistContains(productHandle+'_'+productType)){
//     //                     wishlist_button.classList.add(BUTTON_ACTIVE_CLASS);
                        
                  
//     //                   } 
//     //                   wishlist_button.addEventListener('click', () => {
//     //                     const productHandle = wishlist_button.dataset.productHandle || false;
//     //                     const productType = wishlist_button.dataset.productType || false;
//     //                     updateWishlist(productHandle, wishlist_button);
//     //                     // console.log(productHandle)
//     //                     wishlist_button.classList.toggle(BUTTON_ACTIVE_CLASS);
//     //                     updateWishlistCount();
//     //                     // wishlist_button.querySelector('.icon-heart').classList.toggle('fa-solid')
//     //                     // wishlist_button.querySelector('.icon-heart').classList.toggle('fa-regular')
                        
                      
//     //                   });
//     //                 }
                    
                      
//     //                 }
                    
//     //               }
//     //           }
              
//     //         }
//     //       }
//     //     }
//     //   }  
//     // }
//   });    
// });

// // configuration of the observer:
// var config = { childList: true, subtree:true, attributes: true, attributeOldValue: true, attributeFilter: ['class'] };

// // pass in the target node, as well as the observer options
// // observer.observe(target, config);
// $j('.collection .product-grid').each(function( index ) {
//   var target = $j('.collection .product-grid').get(index);
//   // console.log('target',target)
//   observer.observe(target, config);
  
// });
